// extracted by mini-css-extract-plugin
export default {"fade-in":"classes_fade-in__ijq0C","fadeIn":"classes_fadeIn__Su+zr"};